export const sortByField = (field: string, direction: boolean, rows: Array<any>): Array<any> => {
    return rows.sort((a: any, b: any) => {
        if(direction) {
            return a[field] > b[field] ? 1 : -1;
        } else {
            return a[field] < b[field] ? 1 : -1;
        }
        return 0;
    });
}